import { Helmet } from "react-helmet-async";

const SITE = process.env.REACT_APP_SITE_URL || "https://kbmusic.sk";
const SITE_NAME = "KB MUSIC";
const DEFAULT_DESC = "Profesionálne ozvučenie, osvetlenie a kompletná technická produkcia eventov na Slovensku. Špičková technika, 10+ rokov skúseností.";
const DEFAULT_IMG = `${SITE}/logo-kb.png`;

export default function SEO({
    title,
    description = DEFAULT_DESC,
    keywords,
    canonical,
    ogImage = DEFAULT_IMG,
    ogImageAlt,
    ogType = "website",
    noIndex = false,
    jsonLd,
}) {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Profesionálne Ozvučenie & Osvetlenie Eventov`;
    const canonicalUrl = canonical ? `${SITE}${canonical}` : null;
    const imageAlt = ogImageAlt || fullTitle;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
            {noIndex && <meta name="robots" content="noindex,nofollow" />}

            {/* Open Graph */}
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="sk_SK" />
            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={imageAlt} />
            {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

            {/* Twitter / X */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            <meta name="twitter:image:alt" content={imageAlt} />

            {/* Structured data */}
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
